import Chip from '@mui/material/Chip'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import { RaRecord } from 'ra-core'
import {
    CreateButton,
    Datagrid,
    FilterButton,
    FunctionField,
    List,
    ListProps,
    Pagination,
    sanitizeListRestProps,
    TextField,
    TopToolbar,
    useRedirect,
    useTranslate
} from 'react-admin'
import styled from 'styled-components'
import { formatDateString } from 'utils/formatDateString'
import DateFieldCustom from 'utils/overrides/DateFieldCustom'
import { DEFAULT_PER_PAGE, ROWS_PER_PAGE } from '../../globalVariables'
import RetailerRepresentativeListFilter from './RetailerRepresentativeListFilter'

const ListActions = (props) => {
    const { className, maxResults, forceUpdate, ...rest } = props

    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <FilterButton />
            <CreateButton />
        </TopToolbar>
    )
}

const RetailerRepresentativeList = (props: ListProps) => {
    const redirect = useRedirect()

    const handleLinkRetailer = (event, record) => {
        event.stopPropagation()
        event.preventDefault()
        console.info(record)
        redirect('edit', `/Retailer/${record.id}/representatives`)
    }

    const translate = useTranslate()
    const RESOURCE = 'RetailerRepresentative'

    const forceUpdate = () => window.location.reload()

    return (
        <ListWrapper>
            <List
                sx={{
                    '& .RaDatagrid-headerCell': {
                        fontWeight: 700
                    },
                    form: {
                        minHeight: 'unset',
                        alignItems: 'center',
                        '.MuiFormControl-root': {
                            marginTop: '0 !important'
                        },
                        '.filter-field': {
                            alignItems: 'center',
                            '.RaFilterFormInput-hideButton': {
                                marginBottom: 0
                            }
                        }
                    }
                }}
                resource={RESOURCE}
                sort={{ field: 'name', order: 'ASC' }}
                empty={false}
                perPage={DEFAULT_PER_PAGE}
                filters={RetailerRepresentativeListFilter}
                actions={<ListActions forceUpdate={forceUpdate} />}
                pagination={<Pagination rowsPerPageOptions={ROWS_PER_PAGE} />}
            >
                <Datagrid
                    body={<CustomDatagridBody />}
                    bulkActionButtons={false}
                    rowClick={false}
                    onClick={() => false}
                >
                    <TextField
                        source="name"
                        label={translate('manager.resources.contactPersons.name')}
                    />
                    <TextField
                        source="email"
                        label={translate('manager.resources.contactPersons.email')}
                    />
                    <TextField
                        source="telephone"
                        label={translate('manager.resources.contactPersons.phone')}
                    />
                    <FunctionField
                        label={translate('manager.resources.contactPersons.retailers')}
                        render={(record: RaRecord) => {
                            return record?.retailers && record.retailers.length > 0 ? (
                                record.retailers.map((retailer) => (
                                    <Chip
                                        onClick={(event) => handleLinkRetailer(event, retailer)}
                                        size="small"
                                        label={retailer.name}
                                        sx={{ margin: '2px' }}
                                    />
                                ))
                            ) : (
                                <> — </>
                            )
                        }}
                    />
                    <DateFieldCustom
                        label={translate('manager.resources.general.last_updated')}
                        source="updated_at"
                        showTime
                        transform={(value) => formatDateString(value, true)}
                    />
                </Datagrid>
            </List>
        </ListWrapper>
    )
}

const ListWrapper = styled.section`
    & .MuiToolbar-root {
        > form {
            flex-wrap: initial;
        }
        > div.MuiToolbar-root {
            width: auto;
        }
    }
`
export default RetailerRepresentativeList
